<span class="label2 label-info" (click)="onClick($event)" (keydown)="onEvent($event)" (keyup)="onEvent($event)" #comRef>{{label}}
  <span (click)="removeVariable($event);" (keydown)="onEvent($event)">&times;</span>
</span>